import {ApiConfig} from "@iflat/iflat-ui/src/api/apiConfig";
import {ENTITIES} from "@/lib/helpConst";
import inspectionApi from "@/modules/Inspection/api/inspectionApi";
import houseApi from "@/modules/Object/api/houseApi";
import districtApi from "@/modules/Object/api/districtApi";
import clientApi from "@/modules/Client/api/clientApi";
import inspectionStatusApi from "@/modules/Inspection/api/inspectionStatusApi";
import fileApi from "@/modules/Attachments/api/fileApi";
import checkListApi from "@/modules/Inspection/api/checkListApi";
import remarkTemplateApi from "@/modules/Remark/api/remarkTemplateApi";
import standardApi from "@/modules/Standard/api/standardApi";
import inspectionStepsApi from "@/modules/Inspection/api/inspectionStepsApi";
import companyApi from "@/modules/Company/api/companyApi";
import cityApi from "@/modules/City/api/cityApi";
import companyBadgeApi from "@/modules/Company/api/companyBadgeApi";
import companyTagApi from "@/modules/Company/api/companyTagApi";


export class ApiFactory {
  create (entityName) {
    switch (entityName) {
      case ENTITIES.INSPECTION:
        return new ApiConfig(inspectionApi)
      case ENTITIES.INSPECTION_STEP:
        return new ApiConfig(inspectionStepsApi)
      case ENTITIES.HOUSE:
        return new ApiConfig(houseApi)
      case ENTITIES.DISTRICT:
        return new ApiConfig(districtApi)
      case ENTITIES.CLIENT:
        return new ApiConfig(clientApi)
      case ENTITIES.INSPECTION_STATUS:
        return new ApiConfig(inspectionStatusApi)
      case ENTITIES.FILE:
        return new ApiConfig(fileApi)
      case ENTITIES.CHECK_LIST:
        return new ApiConfig(checkListApi)
      case ENTITIES.REMARK_TEMPLATES:
        return new ApiConfig(remarkTemplateApi)
      case ENTITIES.STANDARD:
        return new ApiConfig(standardApi)
      case ENTITIES.COMPANY:
        return new ApiConfig(companyApi)
      case ENTITIES.CITY:
        return new ApiConfig(cityApi)
      case ENTITIES.COMPANY_BADGE:
        return new ApiConfig(companyBadgeApi)
      case ENTITIES.COMPANY_TAG:
        return new ApiConfig(companyTagApi)
    }
  }
}
